module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"member":"Member","search":"Search by name or email","result":"{n} result | {n} results"},"th":{"member":"สมาชิก","search":"ค้นหาชื่อ อีเมล","result":"{n} ผลการค้นหา"}}')
  delete Component.options._Ctor
}
